module.exports = __webpack_public_path__ + "static/media/a2.8534ccd3.jpg";